import { PaymentDeliveryMethodType } from '@routable/shared';
import { useLocation } from 'react-router-dom';
import { useSelectorWithProps } from 'hooks';
import { partnershipRequestFromLocationSelector } from 'selectors/partnershipRequestSelectors';
export const usePartnershipRequestAvailableBankCurrencies = () => {
    const location = useLocation();
    const partnershipRequest = useSelectorWithProps(partnershipRequestFromLocationSelector, { location });
    return (partnershipRequest?.fundingRoutes || [])
        .filter((route) => route.deliveryMethod === PaymentDeliveryMethodType.INTERNATIONAL)
        .map((route) => route.currencyCodeReceiver);
};
